var urlPreselect = false;
var urlPseselectLoaded = true;

document.addEventListener("DOMContentLoaded", function () {
  // Function to update the boxes and prices based on the quantity selected
  function updateQuantityAndPrice(quantity) {
    // Get the div with the `option-e` class corresponding to the `data-quantity`
    const selectedDiv = document.querySelector(
      `.rc_block__type--active .option-d[data-quantity="${quantity}"]`
    );
    if (selectedDiv) {
      // Check if the `discount-tag-e` class exists in that div
      const discountTag = selectedDiv.querySelector(".price-custom-d");
      if (discountTag) {
        // Get the value of `data-percentage`
        const discountPercentage = parseFloat(
          discountTag.getAttribute("data-percentage")
        );
        if (!isNaN(discountPercentage)) {
          // Calculate the price with the discount
          const originalPrice = parseFloat(
            price1.textContent.replace("$", "").trim()
          ); // Use price1 for original price
          let discountedPrice =
            originalPrice * ((100 - discountPercentage) / 100);
          // Update items with discounted price
          render.forEach(
            (item) => (item.textContent = `$${discountedPrice.toFixed(2)}`)
          );
          renderWithSave.forEach(
            (item) => (item.textContent = `$${Math.trunc(discountedPrice * 100) / 100}`)
          );
          document
            .querySelectorAll(".ea-test")
            .forEach((span) => (span.style.display = "inline"));

          // Update badgeSave with the difference
          const price3Value = parseFloat(
            price3.textContent.replace("$", "").trim()
          );
          const difference = price3Value - discountedPrice;
          const badgeElement = document.querySelector(".product-block--price .badge.price__badge-sale.badge--sale");

          if(difference == 0) {
            price3.style.display='none';
            badgeElement.style.display='none';
          } else {
            price3.style.display='inline';
            badgeElement.style.display='inline-block';
          }

          badgeSave.forEach(
            (badge) => (badge.textContent = `$${difference.toFixed(2)}`)
          );
        } else {
          // If there is no discount, show the original price
          render.forEach((item) => (item.textContent = price1.textContent));
          renderWithSave.forEach((item) => (item.textContent = price1.textContent));
          document
            .querySelectorAll(".ea-test")
            .forEach((span) => (span.style.display = "none"));

          // Reset badgeSave
          const price3Value = parseFloat(
            price3.textContent.replace("$", "").trim()
          );
          const originalPrice = parseFloat(
            price1.textContent.replace("$", "").trim()
          );
          const difference = price3Value - originalPrice;
          const badgeElement = document.querySelector(".product-block--price .badge.price__badge-sale.badge--sale");
 
          if(difference == 0) {
            price3.style.display='none';
            badgeElement.style.display='none';
          } else {
            price3.style.display='inline';
            badgeElement.style.display='inline-block';
          }

          badgeSave.forEach(
            (badge) => (badge.textContent = `$${difference.toFixed(2)}`)
          );
        }
      } else {
        // If there is no discount, show the original price
        render.forEach((item) => (item.textContent = price1.textContent));
        renderWithSave.forEach((item) => (item.textContent = price1.textContent));
        document
          .querySelectorAll(".ea-test")
          .forEach((span) => (span.style.display = "none"));

        // Reset badgeSave
        const price3Value = parseFloat(
          price3.textContent.replace("$", "").trim()
        );
        const originalPrice = parseFloat(
          price1.textContent.replace("$", "").trim()
        );
        const difference = price3Value - originalPrice;
        const badgeElement = document.querySelector(".product-block--price .badge.price__badge-sale.badge--sale");
 
        if(difference == 0) {
          price3.style.display='none';
          badgeElement.style.display='none';
        } else {
          price3.style.display='inline';
          badgeElement.style.display='inline-block';
        }

        badgeSave.forEach(
          (badge) => (badge.textContent = `$${difference.toFixed(2)}`)
        );
      }

      // Manipulate the `selected-e` class
      document.querySelectorAll(".option-d").forEach((option) => {
        option.classList.remove("selected-d");
      });
      selectedDiv.classList.add("selected-d");
    } else {
      // If no div is selected, show the original price
      render.forEach((item) => (item.textContent = price1.textContent));
      renderWithSave.forEach((item) => (item.textContent = price1.textContent));
      document
        .querySelectorAll(".ea-test")
        .forEach((span) => (span.style.display = "none"));

      // Reset badgeSave
      const price3Value = parseFloat(
        price3.textContent.replace("$", "").trim()
      );
      const originalPrice = parseFloat(
        price1.textContent.replace("$", "").trim()
      );
      const difference = price3Value - originalPrice;
      const badgeElement = document.querySelector(".product-block--price .badge.price__badge-sale.badge--sale");

      if(difference == 0) {
        price3.style.display='none';
        badgeElement.style.display='none';
      } else {
        price3.style.display='inline';
        badgeElement.style.display='inline-block';
      }

      badgeSave.forEach(
        (badge) => (badge.textContent = `$${difference.toFixed(2)}`)
      );
    }
  }

  // Listen for changes in the sticky select
  const stickySelect = document.querySelector(".quantity__select-sticky-atc");
  if (stickySelect) {
    stickySelect.addEventListener("change", function () {
      const quantity = stickySelect.value;
      updateQuantityAndPrice(quantity);
    });
  }

  // Listen for clicks on upsell-discounts and select the corresponding option
  document.querySelectorAll(".upsell-discount").forEach((discount) => {
    discount.addEventListener("click", function () {
      const dataItems = this.getAttribute("data-items");

      let quantity;
      if (dataItems.includes("BUY 2")) {
        quantity = "2";
      } else if (dataItems.includes("BUY 3")) {
        quantity = "3";
      } else if (dataItems.includes("BUY 4")) {
        quantity = "4";
      }

      if (quantity) {
        updateQuantityAndPrice(quantity);

        // Update the sticky select
        if (stickySelect) {
          stickySelect.value = quantity;
          stickySelect.dispatchEvent(new Event("change"));
        }
      }
    });
  });

  const radioElements = document.querySelectorAll('[name="purchase_type"]');
  const button1 = document.getElementById("button1");
  const button2 = document.getElementById("button2");
  const button3 = document.getElementById("button3");
  const pricingTableD = document.querySelector(".pricing-table-d");
  const mobileWrapperFixAlign = document.querySelector(
    ".mobile-wrapper-fix-align"
  );
  const renderWithSave = document.querySelectorAll(
    ".price-item.price-item--sale.price-item--last"
  );
  const badgeSave = document.querySelectorAll(
    ".badge.price__badge-sale.badge--sale .semibold"
  );
  const buyMoreSaveMoreD = document.querySelector(
    ".rc_block__radio-wrapper .buy-more-save-more-d"
  );

  const render = document.querySelectorAll(".price-item.price-item--regular.new");
  const radioElement1 = button3.querySelector(".rc_radio__onetime");
  const radioElement2 = button2.querySelector(".rc_radio__autodeliver");

  const price1 = document.querySelector(".rc_price.rc_price__onetime");
  const price2 = document.querySelector(".rc_price.rc_price__autodeliver");
  const price3 = document.querySelector(".syncPrice");

  const realPrice1 = parseFloat(price1.textContent.trim().replace("$", ""));
  const realPrice2 = parseFloat(price2.textContent.trim().replace("$", ""));
  const comparePrice = parseFloat(price3.textContent.trim().replace("$", ""));
  const result1 = comparePrice - realPrice1;
  const result2 = comparePrice - realPrice2;

  // document.addEventListener("DOMContentLoaded", function () {
  //   if (radioElement1.checked) {
  //     const label1 = radioElement1.nextElementSibling;
  //     label1.click();
  //   } else if (radioElement2.checked) {
  //     const label2 = radioElement2.nextElementSibling;
  //     label2.click();
  //   }
  // });

  button3.addEventListener("click", function () {
    this.querySelector("label").click();

    // Obtener el div con la clase `selected-e`
    const selectedDiv = document.querySelector(".option-d.selected-d");
    if (selectedDiv) {
      // Verificar si existe la clase `discount-tag-e` en ese div
      const discountTag = selectedDiv.querySelector(".price-custom-d");
      if (discountTag) {
        // Obtener el valor de `data-percentage`
        const discountPercentage = parseFloat(
          discountTag.getAttribute("data-percentage")
        );
        if (!isNaN(discountPercentage)) {
          // Calcular el precio con el descuento
          const originalPrice = parseFloat(
            price1.textContent.replace("$", "").trim()
          ); // Usar price1 para el precio original
          let discountedPrice =
            originalPrice * ((100 - discountPercentage) / 100);

          // Actualizar los elementos con el precio descontado
          render.forEach(
            (item) => (item.textContent = `$${discountedPrice.toFixed(2)}`)
          );
          renderWithSave.forEach(
            (item) => (item.textContent = `$${discountedPrice.toFixed(2)}`)
          );
          document
            .querySelectorAll(".ea-test")
            .forEach((span) => (span.style.display = "inline"));

          // Update badgeSave with the difference
          const price3Value = parseFloat(
            price3.textContent.replace("$", "").trim()
          );
          const difference = price3Value - discountedPrice;

          badgeSave.forEach(
            (badge) => (badge.textContent = `$${difference.toFixed(2)}`)
          );
        } else {
          // Si no hay descuento, mostrar el precio original
          render.forEach((item) => (item.textContent = price1.textContent));
          renderWithSave.forEach((item) => (item.textContent = price1.textContent));
          document
            .querySelectorAll(".ea-test")
            .forEach((span) => (span.style.display = "none"));

          // Reset badgeSave
          const price3Value = parseFloat(
            price3.textContent.replace("$", "").trim()
          );
          const originalPrice = parseFloat(
            price1.textContent.replace("$", "").trim()
          );
          const difference = price3Value - originalPrice;
          const badgeElement = document.querySelector(".product-block--price .badge.price__badge-sale.badge--sale");
 
          if(difference == 0) {
            price3.style.display='none';
            badgeElement.style.display='none';
          } else {
            price3.style.display='inline';
            badgeElement.style.display='inline-block';
          }

          badgeSave.forEach(
            (badge) => (badge.textContent = `$${difference.toFixed(2)}`)
          );
        }
      } else {
        // Si no hay descuento, mostrar el precio original
        render.forEach((item) => (item.textContent = price1.textContent));
        renderWithSave.forEach((item) => (item.textContent = price1.textContent));
        document
          .querySelectorAll(".ea-test")
          .forEach((span) => (span.style.display = "none"));

        // Reset badgeSave
        const price3Value = parseFloat(
          price3.textContent.replace("$", "").trim()
        );
        const originalPrice = parseFloat(
          price1.textContent.replace("$", "").trim()
        );
        const difference = price3Value - originalPrice;
        const badgeElement = document.querySelector(".product-block--price .badge.price__badge-sale.badge--sale");
 
        if(difference == 0) {
          price3.style.display='none';
          badgeElement.style.display='none';
        } else {
          price3.style.display='inline';
          badgeElement.style.display='inline-block';
        }

        badgeSave.forEach(
          (badge) => (badge.textContent = `$${difference.toFixed(2)}`)
        );
      }
    } else {
      // Si no hay un div seleccionado, mostrar el precio original
      render.forEach((item) => (item.textContent = price1.textContent));
      renderWithSave.forEach((item) => (item.textContent = price1.textContent));
      document
        .querySelectorAll(".ea-test")
        .forEach((span) => (span.style.display = "none"));

      // Reset badgeSave
      const price3Value = parseFloat(
        price3.textContent.replace("$", "").trim()
      );
      const originalPrice = parseFloat(
        price1.textContent.replace("$", "").trim()
      );
      const difference = price3Value - originalPrice;
      const badgeElement = document.querySelector(".product-block--price .badge.price__badge-sale.badge--sale");
 
      if(difference == 0) {
        price3.style.display='none';
        badgeElement.style.display='none';
      } else {
        price3.style.display='inline';
        badgeElement.style.display='inline-block';
      }

      badgeSave.forEach(
        (badge) => (badge.textContent = `$${difference.toFixed(2)}`)
      );
    }
  });

  button2.addEventListener("click", function () {
    this.querySelector("label").click();
    render.forEach((item) => (item.textContent = price2.textContent));
    renderWithSave.forEach((item) => (item.textContent = price2.textContent));
    document
      .querySelectorAll(".ea-test")
      .forEach((span) => (span.style.display = "none"));

    // Reset badgeSave
    const price3Value = parseFloat(price3.textContent.replace("$", "").trim());
    const difference = price3Value - parseFloat(price2.textContent.replace("$", "").trim());
    const badgeElement = document.querySelector(".product-block--price .badge.price__badge-sale.badge--sale");

    if(difference == 0) {
      price3.style.display='none';
      badgeElement.style.display='none';
    } else {
      price3.style.display='inline';
      badgeElement.style.display='inline-block';
    }

    badgeSave.forEach((badge) => (badge.textContent = `$${difference.toFixed(2)}`));
  });

  const selectOption = (inputId) => {
    const input = document.getElementById(inputId);
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event("change"));
    }
  };

  const updateQuantity = (quantity) => {
    const form = document.getElementById("product-form-main");
    if (!form) {
      return;
    }
    let qtyInput = form.querySelector('[name="quantity"]');
    if (!qtyInput) {
      qtyInput = document.createElement("input");
      qtyInput.type = "hidden";
      qtyInput.name = "quantity";
      form.appendChild(qtyInput);
    }
    qtyInput.value = quantity;

    const stickyQtyInput = document.querySelector(
      ".product__sticky-atc__form .atc-form-quantity"
    );
    if (stickyQtyInput) {
      stickyQtyInput.value = quantity;
    } else {
      //   console.warn('Sticky ATC quantity input not found');
    }

    // Update the quantity selector
    const qtySelect = document.querySelector(
      '[update_form_qty="product-form-main"]'
    );
    if (qtySelect) {
      qtySelect.value = quantity;
      const options = qtySelect.querySelectorAll("option");
      options.forEach((option) => {
        option.removeAttribute("selected");
        if (option.value == quantity) {
          option.setAttribute("selected", "selected");
        }
      });
      qtySelect.dispatchEvent(new Event("change"));
      //   console.log(`Quantity selector updated to ${quantity}`);
    } else {
      //   console.warn(`Quantity selector with attribute update_form_qty="product-form-main" not found`);
    }
  };

  const changeOnPdp = () => {
    document
      .querySelectorAll(".rc_block__type--active")
      .forEach((el) => el.classList.remove("rc_block__type--active"));

    if (button3.querySelector(".rc_radio__onetime").checked) {
      button3.classList.add("rc_block__type--active");
      if (pricingTableD) pricingTableD.style.display = "block";
      if (buyMoreSaveMoreD) buyMoreSaveMoreD.style.display = "block";
      if (mobileWrapperFixAlign) mobileWrapperFixAlign.style.display = "none";
    } else {
      button2.classList.add("rc_block__type--active");
      if (pricingTableD) pricingTableD.style.display = "none";
      if (buyMoreSaveMoreD) buyMoreSaveMoreD.style.display = "none";
      if (mobileWrapperFixAlign) mobileWrapperFixAlign.style.display = "block";
    }

    document.querySelectorAll(".rc_block__type").forEach((block) => {
      if (!block.classList.contains("rc_block__type--active")) {
        block.querySelectorAll(".rc_label, .rc_radio").forEach((item) => {
          item.classList.remove("active-style");
          item.style.color = "";
          item.style.backgroundColor = "";
        });
      }
    });
  };

  radioElements.forEach((rechargeRadio) => {
    rechargeRadio.addEventListener("change", function () {
      if (rechargeRadio.checked) {
        document
          .querySelector(".rc_block__type--active")
          .classList.remove("rc_block__type--active");
        rechargeRadio
          .closest(".rc_block")
          .classList.add("rc_block__type--active");

        if (rechargeRadio.id !== "rc_purchase_type_autodeliver") {
          document
            .querySelectorAll('[name="selling_plan"]')
            .forEach((item) => (item.disabled = true));
        } else {
          document
            .querySelectorAll('[name="selling_plan"]')
            .forEach((item) => (item.disabled = false));
        }

        changeOnPdp();
      }
    });
  });

  document.querySelectorAll(".option-d").forEach((option) => {
    option.addEventListener("click", function (e) {
      e.stopPropagation()
      document
        .querySelectorAll(".option-d")
        .forEach((item) => item.classList.remove("selected-d"));
      this.classList.add("selected-d");
      if(rc_shipping_interval_frequency_CTest && window?.ab_packs){
        rc_shipping_interval_frequency_CTest.querySelector(`option[data-pack="${option.dataset.pack}"]`).selected = true
        rc_shipping_interval_frequency_CTest.dispatchEvent(new Event("change"))
      }
      const quantity = this.getAttribute("data-quantity");
      if (quantity) {
        updateQuantity(quantity);
      } else {
        // console.warn('Selected option does not have a data-quantity attribute');
      }
    });
  });

  // button3.addEventListener("click", function () {
  //   selectOption("rc_purchase_type_onetime3");
  //   button2.querySelector(".rc_radio__autodeliver").checked = false;
  //   changeOnPdp();
  // });

  button3.addEventListener("click", function () {
    // Check if the button already has the active class
    if (!button3.classList.contains("rc_block__type--active")) {
      // If not active, activate OTP selection
      selectOption("rc_purchase_type_onetime3"); // Select the OTP radio button
      button2.querySelector(".rc_radio__autodeliver").checked = false; // Uncheck subscription
      updateQuantity(2);
      changeOnPdp();
    }
  });

  // Listen for the click event on Subscription
  button2.addEventListener("click", function () {
    // Check if the button already has the active class
    if (!button2.classList.contains("rc_block__type--active")) {
      // If not active, activate Subscription selection
      selectOption("rc_purchase_type_autodeliver"); // Select the Subscription radio button
      updateQuantity(1);
      changeOnPdp();
    }
  });


  // Función para establecer la cantidad por defecto en 1
  // function setDefaultQuantity() {
  //   const quantitySelect = document.querySelector(".quantity__select");
  //   const qty = urlPreselect ? urlPreselect : 1;
  //   if (quantitySelect) {
  //     quantitySelect.value = qty;
  //     const event = new Event("change");
  //     quantitySelect.dispatchEvent(event);
  //     // Mostrar el campo de selección después de cambiar el valor
  //     quantitySelect.style.visibility = "visible";
  //     return true;
  //   }
  //   return false;
  // }

  // Intentar seleccionar "One Time Purchase" y establecer la cantidad por defecto varias veces
  // const quantityInterval = setInterval(() => {
  //   // selectOneTimePurchase();
  //   const success = setDefaultQuantity();
  //   if (success) {
  //     clearInterval(quantityInterval);
  //   }
  // }, 100);
  /* document.querySelectorAll(".option-d.sub-ab").forEach(elem => {
    const stickySelect = document.querySelector(".quantity__select-sticky-atc");
    elem.addEventListener("click", e => {
      e.stopPropagation()
      / updateQuantityAndPrice(stickySelect.value) *
    })
  }) */
});

document.addEventListener("DOMContentLoaded", function () {
  const priceRegularSpans = document.querySelectorAll(
    ".price-item.price-item--regular"
  );

  priceRegularSpans.forEach((priceRegularSpan) => {
    if (priceRegularSpan.closest(".price__regular")) {
      const eaTestSpan = document.createElement("span");
      eaTestSpan.className = "ea-test";
      eaTestSpan.textContent = "/ea";

      priceRegularSpan.insertAdjacentElement("afterend", eaTestSpan);
    }
  });

  const priceSaleSpans = document.querySelectorAll(
    ".price-item.price-item--sale.price-item--last"
  );

  priceSaleSpans.forEach((priceSaleSpan) => {
    if (priceSaleSpan.closest(".price__sale")) {
      const eaTestSpan = document.createElement("span");
      eaTestSpan.className = "ea-test";
      eaTestSpan.textContent = "/ea";

      priceSaleSpan.insertAdjacentElement("afterend", eaTestSpan);
    }
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   function selectOneTimePurchase2() {
//     const oneTimePurchaseRadio = document.querySelector(
//       "#rc_purchase_type_onetime3"
//     );
//     if (oneTimePurchaseRadio) {
//       oneTimePurchaseRadio.checked = true;
//       oneTimePurchaseRadio.dispatchEvent(new Event("change"));
//     }
//   }
//   selectOneTimePurchase2();
// });

// document.addEventListener("DOMContentLoaded", function () {
//   function selectSubscription() {
//     const subscriptionButton = document.querySelector("#button2 label"); 
//     if (subscriptionButton) {
//       setTimeout(() => {
//         subscriptionButton.click(); 
//       }, 500); 
//     }
//   }
//   selectSubscription();
// });
